import { Button, TextField } from "@mui/material";
import React, { useState } from "react";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import PrimaryButton from "../components/Button/PrimaryButton";
import { useFormik } from "formik";
import * as Yup from "yup";
import * as API from "../utils/service";
import { StaticRouterLinks } from "../utils/StaticRouterLinks";
import { isNullOrUndefined } from "../utils/utils";
import { StaticAPI } from "../utils/StaticAPI";

export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let [query, setQuery] = useState({
    ucc: searchParams.get("ucc"),
  });

  const uccForm = useFormik({
    initialValues: {
      ucc: !isNullOrUndefined(query?.ucc) ? query?.ucc : "",
    },
    onSubmit: (values, { resetForm }) => {
      setLoading(true);
      localStorage.setItem("ucc", values?.ucc);
      setLoading(false);

      navigate(
        {
          pathname: StaticRouterLinks.loginOTP,
          search: `?${createSearchParams({
            ucc: values?.ucc,
          })}`,
        },
        { replace: true }
      );
    },
  });

  return (
    <div className="flex flex-col justify-between gap-5 w-[88%] lg:w-[72%] h-full md:h-[74%] max-h-[500px] max-w-[335px] md:max-h-max py-5 md:py-0">
      <div className="flex flex-col gap-6 lg:gap-[75px]">
        <div className="flex flex-col gap-3.5 lg:gap-3 text-start lg:text-center">
          <span className="text-xl font-medium">
            Welcome to Pace Stock Broking Services Pvt. Ltd.
          </span>
          {/* <div className="flex flex-col text-base font-normal text-pkt-subheading">
            <span>Just a few quick steps to get started.</span>
            <span className="">Ready to join us? </span>
          </div> */}
        </div>

        <form
          onSubmit={uccForm.handleSubmit}
          className="flex flex-col gap-[18px]"
        >
          <div className="flex flex-col justify-center gap-0.5">
            <TextField
              id="outlined-basic"
              label={"Enter CLient ID"}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  color: "#000",
                  fontSize: "14px",
                  fontFamily: "inherit",
                  "& .MuiOutlinedInput-notchedOutline": {
                    borderColor: "#EAEAEA",
                    borderWidth: "1px",
                    borderRadius: "10px",
                  },
                  "&.Mui-focused": {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#2795BF",
                      borderWidth: "2px",
                      borderRadius: "10px",
                    },
                  },
                  "&:hover:not(.Mui-focused)": {
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#ccc",
                      borderRadius: "10px",
                    },
                  },
                },
                "& .MuiInputLabel-outlined": {
                  color: "#918F90",
                  fontSize: "14px",
                  fontFamily: "inherit",
                  "&.Mui-focused": {
                    color: "#2795BF",
                  },
                },
              }}
              value={uccForm?.values?.ucc}
              onChange={uccForm?.handleChange}
              name="ucc"
              type="text"
              // error={uccForm.touched.ucc}
              error={uccForm.touched.ucc ? uccForm.touched.ucc : false}
            />
            {(uccForm.touched.ucc || uccForm.isSubmitting) &&
            uccForm.errors.ucc ? (
              <span className="errorTextField">{uccForm.errors.ucc}</span>
            ) : null}
          </div>
          <PrimaryButton
            size={"large"}
            name={"Sign up"}
            height={"50px"}
            borderRadius={"10px"}
            type="submit"
            loading={loading}
          />
        </form>
      </div>

      {/* <div className="flex flex-col items-center gap-[18px] w-full">
        <div className="flex flex-row items-center gap-1 text-sm text-center">
          <span className=" text-pkt-heading whitespace-nowrap">
            Already have an account ?
          </span>
          <span
            className=" font-normal text-pkt-primary cursor-pointer  whitespace-nowrap"
            onClick={handleLogin}
          >
            Login Now
          </span>
        </div>
        <div className="text-xs text-pkt-subheading">
          <span>By proceeding , I agree to </span>
          <span
            className="border-dashed border-b-[1.9px] border-pkt-subheading cursor-pointer"
            onClick={handleTermAndCondition}
          >
            T&C
          </span>
          <span> and </span>
          <span
            className="border-dashed border-b-[1.9px] border-pkt-subheading cursor-pointer"
            onClick={handlePrivacyPolicy}
          >
            Privacy policy
          </span>
        </div>
      </div> */}
    </div>
  );
}
